import React, { useState, useEffect, useContext } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import "./style.css";
import {
  getTask,
  createTask,
  updateTask,
  deleteTask,
  ListProjectAssign,
  List_Feedback,
} from "../../../Utility/Api"; // Assuming these API methods are defined
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "bootstrap/dist/css/bootstrap.min.css"; // Import Bootstrap CSS
import { toast } from "react-toastify";
import { WarehouseContext } from '../../../Utility/UserContext';
import { NaviGate } from "../../../Utility/function";


const Calender = () => {
  const [view, setView] = useState("month");
  const [showAddTaskModal, setShowAddTaskModal] = useState(false);
  const [showUpdateTaskModal, setShowUpdateTaskModal] = useState(false);
  const [currentTask, setCurrentTask] = useState(null);
  const { showLoader, hideLoader } = useContext(WarehouseContext);
  const [newTask, setNewTask] = useState({
    notes: "",
    slot_date: "",
    end_date: "",
    sale_id: "1",
  });
  const localizer = momentLocalizer(moment);
  const [events, setEvents] = useState([]);

  useEffect(() => {
    fetchTasks();
  }, []);

  const fetchTasks = async () => {
    try {
      let tasksData = [];
      try {
        const tasks = await getTask();
        tasksData = tasks?.data?.data || [];
      } catch (error) {
        console.error("Error fetching tasks:", error);
      }

      let assignedProjectsData = [];
      try {
        const assignedProjects = await List_Feedback();
        assignedProjectsData = assignedProjects?.data?.data || [];
      } catch (error) {
        console.error("Error fetching assigned projects:", error);
      }

      const allEvents = [
        ...(Array.isArray(tasksData)
          ? tasksData.map((item) => ({
            title: item.notes || "No Title",
            start: new Date(item.slot_date),
            end: new Date(item.end_date),
            id: item.schedule_id,
            event: true
          }))
          : []),
        ...(Array.isArray(assignedProjectsData)
          ? assignedProjectsData.map((item) => ({
            title: item.title || "No Title",
            start: new Date(item.start_date_time),
            end: new Date(item.end_date_time),
            id: item.id,
            event: false
          }))
          : []),
      ];

      setEvents(allEvents);
      console.log("Fetched Events:", allEvents);
    } catch (error) {
      console.error("Unexpected error fetching tasks:", error);
      setEvents([]);
    }
  };


  // View change handler
  const handleViewChange = (newView) => {
    setView(newView);
  };

  // Open Add Task Modal
  const openAddTaskModal = (startDate) => {
    const startDateFormatted = moment(startDate).format("YYYY-MM-DDTHH:mm");
    setNewTask({
      notes: "",
      slot_date: startDateFormatted,
      end_date: startDateFormatted,
      sale_id: "1",
    });
    setShowAddTaskModal(true);
  };

  const closeAddTaskModal = () => {
    setShowAddTaskModal(false);
  };

  // Open Update Task Modal
  const openUpdateTaskModal = (task) => {
    console.log(task)
    if (task?.event) {
      setCurrentTask(task);
      setShowUpdateTaskModal(true);
    }
  };

  // Close Update Task Modal
  const closeUpdateTaskModal = () => {
    setShowUpdateTaskModal(false);
    setCurrentTask(null);
  };

  // Add new task handler
  const handleAddTask = async () => {
    if (!newTask.notes.trim()) {
      toast.error("Task Name is required!");
      return;
    }

    showLoader()

    try {
      const createdTask = await createTask(newTask);
      if (createdTask) {
        fetchTasks()
        toast.success("Task Created successfully");
      }
      hideLoader()
      closeAddTaskModal();
    } catch (error) {
      console.error("Error during task creation:", error);
      hideLoader()
    }
  };

  // Update task handler
  const handleUpdateTask = async (updatedTask) => {
    try {

      const Data = {
        notes: updatedTask.title,
        slot_date: updatedTask.start,
        end_date: updatedTask.end,
      }
      const updatedEvent = await updateTask(updatedTask.id, Data);
      if (updatedEvent) {
        toast.success("Task Updated Successfully")
        hideLoader()
        fetchTasks()
      }
      closeUpdateTaskModal();
    } catch (error) {
      alert("Error updating task.");
      hideLoader()
    }
  };

  const handleDeleteTask = async (taskId) => {
    try {
      // Call the deleteTask API to delete the task
      await deleteTask(taskId);
      fetchTasks()
      hideLoader()
      closeUpdateTaskModal();
      fetchTasks()
    } catch (error) {
      console.error("Error deleting task:", error);
      alert("Error deleting task.");
      hideLoader()
    }
  };
  const commonColors = ["#265985", "#2d6d2f", "#d9534f", "#f0ad4e"]; // Define 4 common colors


  return (
    <div className="">
      <div className="page-wrappers">
        <div className="page-content">

          <NaviGate />

          <div className="mb-0 d-flex justify-content-between align-items-center">
            <h6 className="mb-0 text-uppercase" style={{ fontFamily: "poppins" }}>Calendar List</h6>
            <button
              onClick={() => openAddTaskModal(new Date())}
              type="button"
              className="btn btn-primary mb-0 text-normal rounded-1"
            >
              Add Calendar
            </button>
          </div>
          <hr className="mt-1" />

          {/* Bootstrap Card */}
          <div className="card">
            <div className="card-body">
              <div className="mb-4 d-flex justify-content-between align-items-center">
                <h3 className="text-lg font-bold">Task Scheduling</h3>
              </div>

              {/* Calendar Component */}
              <Calendar
                localizer={localizer}
                events={events}
                startAccessor="start"
                endAccessor="end"
                style={{ height: 500}}
                view={view}
                onView={handleViewChange}
                onSelectSlot={({ start }) => openAddTaskModal(start)} // Open modal on date box click
                selectable
                popup
                eventPropGetter={
                  (event) => {
                    let eventStyle = {
                      backgroundColor: "#dff0d8",
                    };
                    let projectStyle = {
                      backgroundColor: "#2d6d2f",
                    };

                    return {
                      className: "",
                      style: event?.event ? eventStyle : projectStyle
                    };
                  }
                }
                onSelectEvent={openUpdateTaskModal} // Open update modal on event click
              />
            </div>
          </div>

          {/* Add Task Modal */}
          {showAddTaskModal && (
            <div
              className="modal show"
              tabIndex="-1"
              style={{ display: "block" }}
            >
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header border-0">
                    <h5 className="modal-title text-normal">Add Task</h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={closeAddTaskModal}
                    ></button>
                  </div>
                  <div className="modal-body">
                    <div className="form-group mb-3 d-flex align-items-center ">
                      <label className="col-3 mb-0 text-normal">Task Name</label>
                      <input
                        type="text"
                        className="form-control mb-2 text-normal"
                        placeholder="Task Title"
                        value={newTask.notes}
                        onChange={(e) =>
                          setNewTask({ ...newTask, notes: e.target.value })
                        }
                        required
                      />
                    </div>
                    <div className="form-group mb-3 d-flex align-items-center ">
                      <label className="col-3 mb-0 text-normal">Slot Date</label>
                      <input
                        type="datetime-local"
                        className="form-control mb-2 text-normal"
                        value={newTask.slot_date}
                        onChange={(e) =>
                          setNewTask({ ...newTask, slot_date: e.target.value })
                        }
                      />
                    </div>
                    <div className="form-group mb-3 d-flex align-items-center ">
                      <label className="col-3 mb-0 text-normal">End Date</label>
                      <input
                        type="datetime-local"
                        className="form-control mb-2 text-normal"
                        value={newTask.end_date}
                        onChange={(e) =>
                          setNewTask({ ...newTask, end_date: e.target.value })
                        }
                      />
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary text-normal rounded-1"
                      onClick={closeAddTaskModal}
                    >
                      Close
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary text-normal rounded-1"
                      onClick={handleAddTask}
                    >
                      Add Task
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Update Task Modal */}
          {showUpdateTaskModal && currentTask && (
            <div
              className="modal show"
              tabIndex="-1"
              style={{ display: "block" }}
            >
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Update Task</h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={closeUpdateTaskModal}
                    ></button>
                  </div>
                  <div className="modal-body">
                    <input
                      type="text"
                      className="form-control mb-2"
                      value={currentTask.title}
                      onChange={(e) =>
                        setCurrentTask({
                          ...currentTask,
                          title: e.target.value,
                        })
                      }
                    />
                    <input
                      type="datetime-local"
                      className="form-control mb-2"
                      value={moment(currentTask.start).format(
                        "YYYY-MM-DDTHH:mm"
                      )}
                      onChange={(e) =>
                        setCurrentTask({
                          ...currentTask,
                          start: new Date(e.target.value),
                        })
                      }
                    />
                    <input
                      type="datetime-local"
                      className="form-control mb-2"
                      value={moment(currentTask.end).format("YYYY-MM-DDTHH:mm")}
                      onChange={(e) =>
                        setCurrentTask({
                          ...currentTask,
                          end: new Date(e.target.value),
                        })
                      }
                    />
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={closeUpdateTaskModal}
                    >
                      Close
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={() => handleUpdateTask(currentTask)}
                    >
                      Update
                    </button>
                    <button
                      type="button"
                      className="btn btn-danger"
                      onClick={() => handleDeleteTask(currentTask.id)}
                    >
                      Delete Task
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Calender;
